export default __webpack_public_path__ + "static/media/icon_calendar_off.b78bf110.svg";